import { unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const LoaderContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: ${unit('sm')};
`;
